<template>
  <div class="product_image">
    <modal v-if="isModalVisible" @close="closeModal" />
    <img
      ref="productImage"
      :data-src="getImage[0].Url"
      class="cld-responsive"
      :alt="getImage[0].Title"
      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
      @click="showModal()"
      @error="handleImageLoadError"
    />
    <!-- If the zoom-mobile then the tap to expand msg shows -->
    <div v-if="zoomMobile" class="product_image__msg">Tap to Expand</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import modal from "./Modals/ProductMobileCarouselModal.vue";

const MAX_RECOVERY_ATTEMPTS = 10;

export default {
  props: {
    zoomMobile: {
      type: Boolean,
      default: function() {
        return false;
      }
    }
  },
  computed: {
    ...mapGetters("product", ["getImage"])
  },
  methods: {
    showModal() {
      // If the !zoom-mobile then the dialog to zoom the image won't open
      if (!this.zoomMobile) {
        return;
      }
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    handleImageLoadError() {
      if (this.recoveryAttempts < MAX_RECOVERY_ATTEMPTS) {
        this.$refs.productImage.src = this.getImage[0].Url;
        this.recoveryAttempts++;
      } else {
        return;
      }
    }
  },
  components: {
    modal
  },
  data() {
    return {
      isModalVisible: false,
      recoveryAttempts: 0
    };
  }
};
</script>

<style lang="scss" scoped>
.product_image {
  min-width: 126px;
  width: 50%;
  margin: 0 auto 18px auto;

  &__msg {
    bottom: 5px !important;
    color: rgb(102, 103, 102) !important;
    font-size: 12px;
    letter-spacing: 0.75px !important;
    margin-bottom: 15px;
    margin-top: 5px;
  }

  img {
    border: 1px solid rgb(204, 204, 204);
    width: 100%;
    background: #dddbdd
      url("https://res.cloudinary.com/avd/image/upload/v1588193793/ProductPage/placeholder-shimmer.gif")
      repeat-y center;
  }
  @include media-breakpoint-up(sm) {
    width: 50%;
    margin: 0 auto 28px auto;
  }

  @include media-breakpoint-up(md) {
    width: 50%;
    margin-bottom: 30px;
    margin-right: 28px;
  }

  @include media-breakpoint-up(lg) {
    width: 100%;
    margin-right: 0;
  }
}
</style>
